import { AttachMoney } from '@mui/icons-material';
import {
  Box,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Slider,
  Switch,
  TextField,
} from '@mui/material';

export const HotelPropertyFaresFilters = () => {
  // Dummy data
  const dummyFilters = {
    roomName: '',
    board: 'all',
    accessCode: 'all',
    priceRange: [0, 1000] as [number, number],
    reembolsable: false,
  };

  const dummyOptions = {
    boardOptions: ['Room Only', 'Bed & Breakfast', 'Half Board', 'Full Board', 'All Inclusive'],
    providerOptions: [
      { value: 'SUP001', label: 'Supplier A' },
      { value: 'SUP002', label: 'Supplier B' },
      { value: 'SUP003', label: 'Supplier C' },
    ],
    priceRange: [0, 1000] as [number, number],
  };

  const isSliderEnabled = dummyOptions.priceRange[1] > dummyOptions.priceRange[0];

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" gap={1} flexWrap="wrap">

        <TextField
          placeholder="Search by room name"
          size="small"
          value={dummyFilters.roomName}
          onChange={() => {}}
        />

        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel id="board-label">Board</InputLabel>
          <Select
            labelId="board-label"
            value={dummyFilters.board}
            label="Board"
            size="small"
            onChange={() => {}}
          >
            <MenuItem value="all">
              All
            </MenuItem>
            {dummyOptions.boardOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 140 }}>
          <InputLabel id="access-code-label">Provider</InputLabel>
          <Select
            labelId="access-code-label"
            value={dummyFilters.accessCode}
            label="Provider"
            size="small"
            onChange={() => {}}
          >
            <MenuItem value="all">
              All
            </MenuItem>
            {dummyOptions.providerOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box display="flex" gap={2} sx={{ width: 300 }}>
          <AttachMoney color="primary" />
          <Slider
            disabled={!isSliderEnabled}
            value={dummyFilters.priceRange}
            onChange={() => {}}
            valueLabelDisplay="auto"
            min={dummyOptions.priceRange[0]}
            max={dummyOptions.priceRange[1]}
          />
        </Box>

        <FormControlLabel
          control={
            <Switch
              checked={dummyFilters.reembolsable}
              onChange={() => {}}
            />
          }
          label="Only Refundable"
        />

      </Box>
    </Paper>
  );
};
